import { render, staticRenderFns } from "./RTimpressum.vue?vue&type=template&id=6549adb1&scoped=true&"
import script from "./RTimpressum.vue?vue&type=script&lang=js&"
export * from "./RTimpressum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6549adb1",
  null
  
)

export default component.exports